import { api } from '~/services/api';
import { AxiosError } from 'axios';
import ICustomAxiosRequestConfig from '~/services/custom/ICustomAxiosRequestConfig';

type SettingsParams = {
  unit_id: string;
};

export type SettingsProps = {
  qr_code_enabled: boolean;
  tolerance: number;
  table_people: number[];
  tables_in_line: number;
  estimated_wait_time_enabled: boolean;
};

type GetSettingsProps = {
  data?: SettingsProps;
  status?: number;
  message?: string;
};

type SettingsOptions = {
  initialData?: {
    data: SettingsProps;
  };
  keepPreviousData?: boolean;
};

export const getSettings = async (
  params?: SettingsParams,
  serverSide?: { serverSide: boolean }
): Promise<GetSettingsProps> => {
  try {
    const { unit_id } = params as SettingsParams;
    const { data, status } = await api.get(
      `/line/v1/units/${unit_id}/qrcode/settings`,
      {
        serverSide,
      } as ICustomAxiosRequestConfig
    );

    return {
      data: data.data,
      status,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      message: (error.response?.data as any).message,
      status: error.response?.status,
    };
  }
};
